<template>
  <div class="w-full relative items-center px-6 py-0 md:py-7 md:h-20 md:border-b">
            <div class="hidden md:block">
                <div class="max-w-7xl sm:h-full w-full md:flex justify-center items-center mx-auto">
                    <h4 class="text-yank">Social Channels</h4>
                </div>
                <button v-on:click="clicked" class="flex items-center absolute top-20 left-1/2 transform -translate-x-1/2 sm:right-6 sm:top-7 cursor-pointer lg:right-3 lg:transform-none lg:left-auto">
                    <h2 class=" text-carolina mr-3">Add Channel</h2>
                    <PlusIcon/>
                </button>
            </div>
            

            <div class="flex flex-col items-center justify-center md:h-screen space-y-4 mt-10 md:-mt-10">
                <NoAccountLinked/>
                <span class="text-customGray text-center font-semibold w-7/12 md:w-4/12">Looks like you have no accounts linked yet</span>
                <button v-on:click="clicked" class="flex bg-aquamarine text-white rounded-lg px-18 py-4">
                  <span class="mr-2 ">Add Channel</span>
                  <BackArrow color="#FFFFFF" class="h-6 transform rotate-180"/>
                </button>
            </div>
      </div>
</template>

<script>
import PlusIcon from '@/components/svg/Plus'
import NoAccountLinked from '@/components/svg/NoAccountLinked'
import BackArrow from '@/components/svg/BackArrow'
export default {
    name:"MediaEmptySetting",
    components: {
        PlusIcon,
        NoAccountLinked,
        BackArrow
    },

    methods: {
        clicked() {
            this.$emit('goToChannelSetting')
        }
    }
}
</script>
